"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashTrial = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var CashTrial = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CashTrial, _super);
    function CashTrial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷试算接口';
        _this.code = '101128';
        _this.desc = '现金贷试算接口';
        _this.requestParams = new cashLoanAuth_1.CashTrialRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CashTrial;
}(service_1.BaseService));
exports.CashTrial = CashTrial;
//# sourceMappingURL=cashTrial.js.map